module.exports = __webpack_public_path__ + "static/media/pefin-onboarding-05.e6d2dd63.png";